module.exports = __webpack_public_path__ + "img/quizz-step-10-2.478e7a53.jpg";